<div id="errorModal" uk-modal #modal>
  <button class="uk-modal-close-default" type="button" uk-close></button>
  <div class="uk-modal-dialog uk-margin-auto-vertical uk-modal-body">
    <div class="uk-flex uk-flex-center uk-flex-middle">
      <span uk-icon="icon: warning; ratio: 1.3"></span>
      <h2 class="error-modal-header" i18n="@@Warning">Warning</h2>
    </div>
    <div class="uk-modal-body uk-text-center">
      {{ text }}
    </div>
  </div>
</div>
